// extracted by mini-css-extract-plugin
module.exports = {"tooltipContent":"AmendDisabledTooltip_tooltipContent__QwVXK"};